module.exports = __webpack_public_path__ + "static/media/IconPasswordOn.d4c3c927.svg";